<template>
  <v-card>
    <v-form @submit.prevent="submitEditTip()" ref="editTipForm">
      <v-container grid-list-lg>
        <v-layout wrap>
          <dialog-header :title="'Edit'" :details="`${tip.name} (ID: ${tip.id})`"></dialog-header>
          <v-flex xs12 sm6>
            <v-text-field
              v-model="editedTip.name"
              label="* Name"
              autofocus
              :loading="loading"
              :rules="nameRules"
              :color="primaryNeutral"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              label="Tip Number"
              v-model="editedTip.number"
              :loading="loading"
              :rules="numberRules"
              :color="primaryNeutral"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              v-model="editedTip.contactEmail"
              label="Contact Email"
              :loading="loading"
              :rules="contactEmailRules"
              :color="primaryNeutral"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              v-model="editedTip.details"
              label="Details"
              :loading="loading"
              :rules="detailsRules"
              :color="primaryNeutral"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-switch
              label="Tipping docket required?"
              v-model="editedTip.tippingDocketRequired"
              :color="primaryNeutral"
            ></v-switch>
            <v-switch
              label="Weigh Bridge?"
              v-model="editedTip.weighBridge"
              :color="primaryNeutral"
              class="mt-0"
            ></v-switch>
            <v-switch
              label="Request"
              v-model="editedTip.request"
              :disabled="!userAuthClass"
              class="mt-0"
              v-if="$store.state.user.userAuthClass.name === 'Administrator'"
            ></v-switch>
          </v-flex>
          <!-- <v-flex xs12 sm6 v-for="(field, i) in editTipFields" :key=i >
            <v-text-field v-model="editedTip[field.model]" :label="field.label" :rules="field.rules"></v-text-field>
          </v-flex>-->
        </v-layout>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <div v-if="different">
          <v-btn :color="primaryGrey" flat @click="discard()">Discard?</v-btn>
          <v-btn :color="primaryGreen" flat type="submit" :loading="loading">Save</v-btn>
        </div>
        <div v-else>
          <v-btn :color="primaryGrey" flat @click="close()">Close</v-btn>
        </div>
      </v-card-actions>
    </v-form>
    <v-container v-if="!editedTip.request">
      <v-layout>
        <v-flex>
          <v-expansion-panel expand class="grey lighten-3">
            <v-expansion-panel-content v-model="spoilPanel" class="grey lighten-4">
              <div
                slot="header"
                class="font-weight-medium grey--text text--darken-2 vertical-center-container"
              >
                <v-icon
                  :color="spoilColor"
                  class="mr-2"
                >{{this.$store.state.global.pages.spoil.icon}}</v-icon>Allowed Spoils
              </div>

              <v-list subheader>
                <v-list-tile v-for="spoil in spoils" :key="spoil.id" fluid>
                  <v-checkbox
                    v-model="selectedSpoils"
                    :label="spoil.name"
                    :value="spoil.id"
                    :color="spoilColor"
                  ></v-checkbox>
                </v-list-tile>
                <v-divider></v-divider>
                <v-list-tile>
                  <v-checkbox v-model="selectAllSpoils" :color="spoilColor">
                    <div slot="label" class="font-weight-bold">Select All</div>
                  </v-checkbox>
                </v-list-tile>
              </v-list>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container>
      <v-layout>
        <v-flex>
          <v-expansion-panel expand class="grey lighten-3">
            <v-expansion-panel-content v-model="projectPanel" class="grey lighten-4">
              <div
                slot="header"
                class="font-weight-medium grey--text text--darken-2 vertical-center-container"
              >
                <v-icon :color="projectColor" class="mr-2">{{this.$store.state.global.pages.project.icon}}</v-icon>Allowed Projects
              </div>

              <v-list subheader>
                <v-list-tile v-for="project in projects" :key="project.id" fluid>
                  <v-checkbox
                    v-model="selectedProjects"
                    :label="project.name"
                    :value="project.id"
                    :color="projectColor"
                  ></v-checkbox>
                </v-list-tile>
                <v-divider></v-divider>
                <v-list-tile>
                  <v-checkbox v-model="selectAllProjects" :color="projectColor">
                    <div slot="label" class="font-weight-bold">Select All</div>
                  </v-checkbox>
                </v-list-tile>
              </v-list>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
import Store from '@/store/computed/storeHelpers'
import TipService from '@/services/requests/tipService'
import TipSpoilService from '@/services/requests/tipSpoilService'
import ProjectTipService from "@/services/requests/projectTipService";

// MIXINS
import TipValidation from '@/services/validation/tipValidation'
import RouteProps from '@/services/mixins/routeProps'

// COMPONENTS
import DialogHeader from '@/components/ui/dialogHeader'

export default {
  mixins: [TipValidation, RouteProps],
  components: {
    DialogHeader,
  },
  data() {
    return {
      tipSpoils: [],
      selectedSpoils: [],
      currentSpoils: [],
      allSpoils: [],
      selectAllSpoils: false,
      spoilPanel: false,
      spoilColor: this.$store.state.global.pages.spoil.color,
      selectedProjects: [],
      currentProjects: [],
      allProjects: [],
      selectAllProjects: false,
      projectPanel: false,
      projectColor: this.$store.state.global.pages.project.color,
      editedTip: Object.assign({}, this.tip),
      loading: false,
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    snackEmit(options) {
      this.$emit('snack', options)
    },
    discard() {
      this.editedTip = Object.assign({}, this.tip)
      this.selectedSpoils = this.currentSpoils
      this.selectedProjects = this.currentProjects
      this.close()
    },
    submitEditTip() {
      if (!this.$refs.editTipForm.validate()) {
        return
      }
      this.save()
    },
    getTipSpoilsByTip() {
      TipSpoilService.getTipSpoilsByTip(this.tip.id)
        .then((result) => {
          this.setCurrentSpoils(result.data.result)
          this.tipSpoils = result.data.result
        })
        .catch((err) => {
          this.snackError()
          console.log(err)
        })
    },
    setCurrentSpoils(data) {
      this.selectedSpoils = []
      this.currentSpoils = []
      for (var record of data) {
        this.selectedSpoils.push(record.spoilId)
        this.currentSpoils.push(record.spoilId)
      }
    },
    getTipProjectsByTip() {
      ProjectTipService.getProjectTipsByTip(this.tip.id)
        .then((result) => {
          this.setCurrentProjects(result.data.result)
          this.tipProjects = result.data.result
        })
        .catch((err) => {
          this.snackError()
          console.log(err)
        })
    },
    setCurrentProjects(data) {
      this.selectedProjects = []
      this.currentProjects = []
      for (var record of data) {
        this.selectedProjects.push(record.projectId)
        this.currentProjects.push(record.projectId)
      }
    },
    save() {
      var postedTip = this.editedTip
      postedTip.selectedSpoils = this.selectedSpoils
      postedTip.selectedProjects = this.selectedProjects
      this.loading = true
      TipService.updateTip(this.editedTip)
        .then((result) => {
          this.loading = false
          this.$store.commit('tips/updateArrayStateByValue', {
            prop: 'tips',
            value: this.tip,
            editedValue: result.data.result.tip,
          })
          this.editedTip = Object.assign({}, result.data.result.tip)
          this.setCurrentSpoils(result.data.result.tipSpoils)
          this.setCurrentProjects(result.data.result.tipProjects)
          this.snack({ color: 'green', text: 'Tip was edited' })
          this.close()
        })
        .catch((err) => {
          this.loading = false
          console.log(err)
          this.snackError()
        })
    },
  },
  computed: {
    spoils: Store.getSet({ store: 'spoils', prop: 'spoils' }),
    projects: Store.getSet({ store: "projects", prop: "projects" }),
    different() {
      if (
        !this._.isEqual(this.tip, this.editedTip) ||
        !this._.isEqual(
          this.selectedSpoils.sort().join(','),
          this.currentSpoils.sort().join(',')
        ) || 
        !this._.isEqual(
          this.selectedProjects.sort().join(','),
          this.currentProjects.sort().join(',')
        )

      ) {
        return true
      } else {
        return false
      }
    },
  },
  mounted() {
    this.getTipSpoilsByTip()
    for (var spoil of this.spoils) {
      this.allSpoils.push(spoil.id)
    }
    this.getTipProjectsByTip()
    for (var project of this.projects) {
      this.allProjects.push(project.id)
    }
  },
  props: {
    tip: Object,
  },
  watch: {
    selectAllSpoils(val) {
      val ? (this.selectedSpoils = this.allSpoils) : (this.selectedSpoils = [])
    },
    selectAllProjects(val) {
      val ? (this.selectedProjects = this.allProjects) : (this.selectedProjects = [])
    },
  },
}
</script>

<style>
</style>
